"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  primary: {
    primary99: '#f6f7fe',
    primary95: '#edf0ff',
    primary90: '#dae3ff',
    primary80: '#b0c5ff',
    primary70: '#8eacf9',
    primary60: '#6a8dea',
    primary50: '#4f73ce',
    primary40: '#345ab3',
    primary30: '#13419a',
    primary20: '#002a77',
    primary10: '#00174a'
  },
  accent: {
    accent99: '#fdf6fe',
    accent95: '#fbecff',
    accent90: '#f1daff',
    accent80: '#deb7ff',
    accent70: '#cb92ff',
    accent60: '#b56efd',
    accent50: '#9a52e1',
    accent40: '#8036c6',
    accent30: '#6611ac',
    accent20: '#480082',
    accent10: '#2b0052'
  },
  neutral: {
    white100: '#ffffff',
    neutral99: '#fafaff',
    neutral95: '#f3f3f7',
    neutral90: '#e4e3e6',
    neutral80: '#c9c8cb',
    neutral70: '#acabaf',
    neutral60: '#919094',
    neutral50: '#77767a',
    neutral40: '#5e5e62',
    neutral30: '#46464a',
    neutral20: '#303033',
    neutral10: '#1b1b1e'
  },
  variant: {
    variant99: '#f8f8fc',
    variant95: '#efeff6',
    variant90: '#e2e2e9',
    variant80: '#c8c8d0',
    variant70: '#aaabb3',
    variant60: '#909199',
    variant50: '#75767f',
    variant40: '#5c5e67',
    variant30: '#44464e',
    variant20: '#2e3038',
    variant10: '#191b23'
  },
  surface: {
    surface0: '#fafaff',
    surface1: '#f2f4fc',
    surface2: '#eaedf9',
    surface3: '#e4e8f7',
    surface4: '#dde3f4',
    surface5: '#d9dff2'
  },
  error: {
    error99: '#fff7f5',
    error95: '#ffeeeb',
    error90: '#ffdad4',
    error80: '#ffb4a9',
    error70: '#ff897a',
    error60: '#ff5449',
    error50: '#dd3730',
    error40: '#ba1b1b',
    error30: '#930006',
    error20: '#680003',
    error10: '#410001'
  },
  success: {
    success99: '#efffe5',
    success95: '#d8fed2',
    success90: '#9ef89b',
    success80: '#75e175',
    success70: '#54c457',
    success60: '#3aa542',
    success50: '#158a2a',
    success40: '#006e16',
    success30: '#00530e',
    success20: '#003907',
    success10: '#002202'
  },
  alert: {
    alert99: '#fff4ed',
    alert95: '#ffeadb',
    alert90: '#ffd3b8',
    alert80: '#ffb17a',
    alert70: '#ff9338',
    alert60: '#f07700',
    alert50: '#bd5c00',
    alert40: '#974900',
    alert30: '#733600',
    alert20: '#512400',
    alert10: '#311300'
  },
  warning: {
    warning99: '#fff9eb',
    warning95: '#fff3cc',
    warning90: '#ffe285',
    warning80: '#fdd512',
    warning70: '#ddb503',
    warning60: '#af8d00',
    warning50: '#917400',
    warning40: '#745c00',
    warning30: '#574500',
    warning20: '#3d2f00',
    warning10: '#231b00'
  }
};